import { __assign, __extends, __read, __rest, __spread } from "tslib";
import React, { Component } from 'react';
import { noop } from 'lodash';
import { Box } from '../Box';
import Checkbox from './Checkbox';
import { FormError } from './FormError';
import { createEasyInput } from './EasyInput';
import GroupContainer from './GroupContainer';
var CheckboxGroup = (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selected: Array.isArray(_this.props.value) ? __spread(_this.props.value) : [],
        };
        _this.createChangeHandler = function (choice) { return function (_name, value) {
            var selected = _this.state.selected;
            var newSelected;
            if (!selected.includes(value)) {
                if (choice.exclusive) {
                    newSelected = [value];
                }
                else {
                    newSelected = _this.props.choices
                        .filter(function (c) { return !c.exclusive && (c.value === value || selected.includes(c.value)); })
                        .map(function (c) { return c.value; });
                }
            }
            else {
                var index = selected.indexOf(value);
                newSelected = __spread(selected.slice(0, index), selected.slice(index + 1));
            }
            _this.setState({
                selected: newSelected,
            }, function () {
                var _a, _b;
                (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.name, newSelected);
            });
        }; };
        return _this;
    }
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, choices = _a.choices, error = _a.error, horizontal = _a.horizontal, colorOn = _a.colorOn, colorOff = _a.colorOff, checkboxProps = __rest(_a, ["name", "choices", "error", "horizontal", "colorOn", "colorOff"]);
        var selected = this.state.selected;
        return (React.createElement(Box, null,
            React.createElement(GroupContainer, { horizontal: horizontal }, choices.length &&
                choices.map(function (choice) {
                    var _a = choice.value, value = _a === void 0 ? choice.id : _a;
                    var key = "checkbox-" + name + "-" + value;
                    return (React.createElement(Checkbox, __assign({}, checkboxProps, { key: key, id: key, name: key, label: choice.label, colorOn: colorOn, colorOff: colorOff, horizontal: horizontal, value: selected && selected.includes(value) ? value : null, valueTrue: value, valueFalse: value, onChange: _this.createChangeHandler(choice) })));
                })),
            !!error && React.createElement(FormError, null, error)));
    };
    CheckboxGroup.defaultProps = {
        horizontal: false,
        onChange: noop,
        colorOn: 'primary',
        colorOff: 'greyDark',
    };
    return CheckboxGroup;
}(Component));
export { CheckboxGroup };
export default createEasyInput(CheckboxGroup);
//# sourceMappingURL=CheckboxGroup.js.map